export const environment = {
	production: true,
	quizBaseUrl: 'https://quiz.brandmagic.com.au',
	stripePerishableKey: 'pk_live_paBUM2VNEoYEmwRKLj9RbGKQ',
	stripeRefreshUrl: 'https://admin.brandmagic.com.au/stripe/refresh',
	stripeReturnUrl: 'https://admin.brandmagic.com.au/stripe/return',
	brandMagicAdminId: '6385ac111db2728e1579c82e',
};
